import React from 'react';
import styled from 'styled-components';
import { shapeUrl } from '../styles/decor';

/**
 * Formas coloridas flutuando no fundo de uma seção.
 * items: [{ shape:'coxinha'|'bolinha'|'pastel'|'brilho', color, size, top, left|right, rotate, delay }]
 */
const Layer = styled.div`
    position:absolute;
    inset:0;
    overflow:hidden;
    pointer-events:none;
    z-index:0;

    span{
        position:absolute;
        display:block;
        background-repeat:no-repeat;
        background-size:contain;
        background-position:center;
        animation:floaty 9s ease-in-out infinite alternate;
    }

    @keyframes floaty{
        0%{ transform:translate3d(0, 0, 0) rotate(var(--r, 0deg)); }
        100%{ transform:translate3d(0, -18px, 0) rotate(calc(var(--r, 0deg) + 14deg)); }
    }

    @media (max-width:700px){
        span.hideMobile{ display:none; }
    }
`;

const FloatingShapes = ({ items = [] }) => (
    <Layer aria-hidden="true">
        {items.map((it, i) => (
            <span
                key={i}
                className={it.hideMobile ? 'hideMobile' : ''}
                style={{
                    width: it.size,
                    height: it.size,
                    top: it.top,
                    bottom: it.bottom,
                    left: it.left,
                    right: it.right,
                    opacity: it.opacity != null ? it.opacity : 1,
                    backgroundImage: shapeUrl(it.shape, it.color),
                    animationDelay: `${it.delay || 0}s`,
                    animationDuration: `${it.duration || 9}s`,
                    '--r': `${it.rotate || 0}deg`,
                }}
            />
        ))}
    </Layer>
);

export default FloatingShapes;
